import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { color, em, rem, media } from '../../utils/styles'

import FooterWrapper from './FooterWrapper'

export const StyledFooter = styled.footer`
  background-color: ${color('base')};
  padding: ${rem(32)} 0;
  color: ${color('white')};
  font-size: ${em(16)};

  ${media('tablet')`
    padding-top: ${rem(40)};
    padding-bottom: ${rem(40)};
  `}

  ${media('desktop')`
    padding-top: ${rem(120)};
    padding-bottom: ${rem(50)};
  `}
`

function Footer({ children }) {
  return (
    <StyledFooter>
      <FooterWrapper>
        {children}
      </FooterWrapper>
    </StyledFooter>
  )
}

Footer.propTypes = {
  children: PropTypes.node
}

export default Footer
